import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import TextField, { TextFieldProps } from "@mui/material/TextField"; // Import TextFieldProps
import { forwardRef, useState } from "react"; // Import forwardRef

// Keep original props if they are just TextFieldProps
// If PasswordInputProps had its own unique props, they'd be defined here.
// For now, it seems PasswordInputProps is equivalent to TextFieldProps.
// We can use TextFieldProps directly or define PasswordInputProps if it might diverge.
type PasswordInputProps = TextFieldProps;

const PasswordInput = forwardRef<HTMLDivElement, PasswordInputProps>(
  ({ InputProps, type, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);
    // The 'color' prop was destructured but not used; it will be passed via ...props.
    return (
      <TextField
        ref={ref} // Forward the ref
      type={showPassword ? "text" : "password"}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <div className="cursor-pointer" onClick={() => setShowPassword((prev) => !prev)}>
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </div>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
});

export default PasswordInput;
